module.exports = __webpack_public_path__ + "img/21-Skin.852adec9.png";